const getters = {
  sidebar: state => state.app.sidebar,
  dynamicRoutes: state => state.auth.dynamicRoutes,
  permissionCodes: state => state.auth.permissionCodes,
  token: state => state.auth.token,
  avatar: state => state.auth.avatar,
  name: state => state.auth.name,
  roles: state => state.auth.roles,
  userUuid: state => state.auth.userUuid,
  userId: state => state.auth.userId,
  userDuty: state => state.auth.userDuty,
  language: state => 'zh',
  realname: state => state.auth.realname,
  currentSystem: state => state.auth.currentSystem
}
export default getters
